import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { Observable } from 'rxjs';
import { AsyncPipe } from '@angular/common';

@Component({
    templateUrl: './success-message.component.html',
    styleUrls: ['./success-message.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [AsyncPipe]
})
export class SuccessMessageComponent {
  constructor(private matSnackBarRef: MatSnackBarRef<SuccessMessageComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public message: Observable<string>) {
  }

  dismiss() {
    this.matSnackBarRef.dismiss();
  }
}
